module.exports = global["HandshqApp"] = require("-!/tmp/build_8949d918/node_modules/babel-loader/lib/index.js??ref--10-0!./handshq-app.js");